// src/services/support.service.js
import { api } from './api';

class SupportService {
    async submitBugReport({ title, description, severity = 'medium' }) {
        const response = await api.post('/api/support/bug-report', {
            title,
            description,
            severity,
            pageUrl: typeof window !== 'undefined' ? window.location.href : '',
            userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : ''
        });
        return response.data;
    }
}

const supportService = new SupportService();
export default supportService;
